import { LegalLayout } from "../components/legal/LegalLayout";

const AvisoLegal = () => {
  return (
    <LegalLayout title="Aviso legal" eyebrow="Información legal">
      <p>
        En cumplimiento de lo establecido en la Ley 34/2002, de 11 de julio, de
        Servicios de la Sociedad de la Información y Comercio Electrónico
        (LSSI-CE), se facilita a continuación la información legal relativa al
        sitio web.
      </p>

      <h2>1. Datos identificativos del titular</h2>
      <ul>
        <li>
          <strong>Titular:</strong> Aitor [Apellidos] (en adelante, "el
          Titular").
        </li>
        <li>
          <strong>Marca comercial:</strong> Aitor | Nutrición y Entrenamiento.
        </li>
        <li>
          <strong>NIF:</strong> [Pendiente de cumplimentar].
        </li>
        <li>
          <strong>Domicilio profesional:</strong> C/ Berriobide, Pamplona
          (Navarra), España.
        </li>
        <li>
          <strong>Email de contacto:</strong>{" "}
          <a href="mailto:contacto@aitornutricion.com">
            contacto@aitornutricion.com
          </a>
          .
        </li>
        <li>
          <strong>Teléfono / WhatsApp:</strong> 000 000 000 000.
        </li>
      </ul>
      <p className="text-sm text-zinc-500">
        Los datos marcados como "[Pendiente]" deben ser completados por el
        Titular antes de la puesta en producción del sitio.
      </p>

      <h2>2. Objeto</h2>
      <p>
        El presente Aviso Legal regula el uso del sitio web cuyo titular es
        Aitor (en adelante, "el sitio web"). La navegación por el sitio web
        atribuye la condición de usuario e implica la aceptación plena y sin
        reservas de todas y cada una de las disposiciones incluidas en este
        Aviso Legal.
      </p>

      <h2>3. Condiciones de uso</h2>
      <p>
        El usuario se compromete a hacer un uso adecuado y lícito del sitio
        web, así como de los contenidos y servicios, de conformidad con la
        legislación aplicable, el presente Aviso Legal, las buenas costumbres y
        el orden público.
      </p>
      <p>
        Queda prohibida cualquier actuación que pueda dañar, inutilizar,
        sobrecargar o deteriorar el sitio web o impedir el normal disfrute del
        mismo por parte de los usuarios.
      </p>

      <h2>4. Servicios ofrecidos</h2>
      <p>
        A través del sitio web se ofrece información sobre servicios de
        asesoramiento en nutrición y entrenamiento personalizado, en modalidad
        presencial (Pamplona) y online. La contratación efectiva de los
        servicios se formaliza fuera del sitio web, mediante WhatsApp u otros
        canales acordados con el Titular.
      </p>

      <h2>5. Propiedad intelectual e industrial</h2>
      <p>
        Todos los contenidos del sitio web (textos, imágenes, fotografías,
        diseño gráfico, código fuente, logotipos, marcas, etc.) son titularidad
        del Titular o de terceros que han autorizado su uso, y se encuentran
        protegidos por la normativa de propiedad intelectual e industrial.
      </p>
      <p>
        Queda prohibida la reproducción, distribución, comunicación pública,
        transformación o cualquier otra forma de explotación, total o parcial,
        de los contenidos sin autorización expresa y por escrito del Titular.
      </p>

      <h2>6. Exclusión de responsabilidad</h2>
      <p>
        La información publicada en el sitio web tiene carácter meramente
        informativo y no sustituye en ningún caso el asesoramiento médico
        individualizado. Antes de iniciar cualquier plan de nutrición o
        entrenamiento, el usuario debe consultar a un profesional sanitario.
      </p>
      <p>
        El Titular no se hace responsable de los daños o perjuicios derivados
        del uso indebido de la información publicada, ni de las interrupciones,
        virus o fallos técnicos que pudieran producirse durante la conexión a
        Internet.
      </p>

      <h2>7. Enlaces a terceros</h2>
      <p>
        El sitio web puede contener enlaces a páginas de terceros (por ejemplo,
        WhatsApp o redes sociales). El Titular no asume responsabilidad alguna
        sobre el contenido, políticas o prácticas de dichos sitios externos.
      </p>

      <h2>8. Modificaciones</h2>
      <p>
        El Titular se reserva el derecho a efectuar, en cualquier momento y sin
        necesidad de previo aviso, las modificaciones que considere oportunas
        en el sitio web, así como en el presente Aviso Legal.
      </p>

      <h2>9. Legislación y jurisdicción aplicable</h2>
      <p>
        El presente Aviso Legal se rige por la legislación española. Para
        cualquier controversia derivada del uso del sitio web, las partes se
        someten expresamente a los Juzgados y Tribunales de Pamplona (Navarra),
        salvo que la normativa aplicable disponga lo contrario.
      </p>
    </LegalLayout>
  );
};

export default AvisoLegal;
